import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const productsJsmAuthenticationSettingsRoute: InvariantJiraRoute = {
	name: 'products-jsm-authentication-settings',
	path: '/jira/settings/products/servicedesk/authentication',
	exact: true,
};
